import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import Header from "../../../../components/header";
import { AdminClerksState } from '../hooks/use-admin-clerks';

type AdminClerksHeaderProps = {
	state: AdminClerksState;
}

const AdminClerksHeader = (props: AdminClerksHeaderProps) => {
	const adminClerksState: AdminClerksState = props.state;

	return (
		<>
			<Header>
				<div className="container flex flex-row w-full mx-auto">
					<div className="container mx-auto mb-6 text-3xl font-semibold text-white">
						Clerks
					</div>
					<div className="flex flex-row justify-end w-full">
						<div className="flex flex-col">
							<div className="container flex items-center gap-2 px-6 py-2 mx-auto mb-6 bg-white rounded-full">
								<MagnifyingGlassIcon className="w-8 h-8 text-gray-500" />
								<input
									key="search-input"
									className="w-full m-2 text-lg outline-none"
									placeholder="Search"
									value={adminClerksState.query}
									onChange={(e) => adminClerksState.setQuery(e.target.value)}
								/>
							</div>
						</div>
					</div>
				</div>
			</Header>
			<div className="p-12 pt-6 pb-6">
				<div className="flex flex-row justify-end gap-4">
					<div className="flex items-center gap-2">
						<input
							id="showCompletedTestDecks"
							type="checkbox"
							checked={adminClerksState.showAdmin}
							className="w-5 h-5 border-primary-blue hover:cursor-pointer"
							onChange={(e) =>
								adminClerksState.updateShowAdminClerks(
									e.target.checked
								)
							}
						/>
						<label
							htmlFor="showCompletedTestDecks"
							className="select-none hover:cursor-pointer"
						>
							Show Admin Clerks
						</label>
					</div>
					<div className="flex items-center gap-2">
						<input
							id="showCompletedTestDecks"
							type="checkbox"
							checked={adminClerksState.showDeleted}
							className="w-5 h-5 border-primary-blue hover:cursor-pointer"
							onChange={(e) =>
								adminClerksState.updateShowDeletedClerks(
									e.target.checked
								)
							}
						/>
						<label
							htmlFor="showCompletedTestDecks"
							className="select-none hover:cursor-pointer"
						>
							Show Deleted Clerks
						</label>
					</div>
				</div>
			</div>
		</>
	);
};

export default AdminClerksHeader;
